import { useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { calculateTotals, getCartOptions } from "@/utils/cart";

import {
  CartList,
  CartNotification,
  EmptyCart,
  PopUpFooter,
  PopUpHeader,
} from "../components";
import { getPopUpWrapperStyles } from "./styles";
import {fetchCartById} from "@/api/fetchCartById.ts";
import {useGetProductsQuery} from "@/redux-store/api/marketingApi.ts";
import {useAppDispatch, useAppSelector} from "@/redux-store/hooks";
import {setCartData, setCartId} from "@/redux-store/cart/cartSlice.ts";
import { ROUTES } from "@/utils/navigation";
import { useNavigate } from "react-router-dom";

interface IProps {
  closePopUp: () => void;
}

const CartPopUp: React.FC<IProps> = ({ closePopUp }) => {
  const isSmallMobile = useMediaQuery("(max-width: 374.98px)");
  const { data } = useGetProductsQuery({});
  const dispatch = useAppDispatch();
  const { products, totalItems, totalAmount, hasPlan, hasDevice, cartId } = useAppSelector(state => state.cart);
  const sessionId = useAppSelector((state) => state.cart.sessionId);
  const navigate = useNavigate();

  useEffect(() => {
    const getCheckoutData = async (id: string | number) => {
      try {
        const checkoutData = (await fetchCartById(id))!;
        dispatch(setCartId(checkoutData.id));
        if (data) {
          const updatedProducts = checkoutData.items?.map((item) => {
            const productData = data.find((product) => product.id === item.idProduct);
            return {
              ...item,
              name: productData?.name || "No Name",
              image: productData?.image || "No Image",
              realPrice: productData?.price || 0,
            };
          });

          // Calculate totals
          const { totalQuantity, totalAmount } = calculateTotals(updatedProducts || []);
          const { hasPlan, hasDevice } = getCartOptions(updatedProducts || []);

          dispatch(setCartData({
            products: updatedProducts || [],
            totalItems: totalQuantity,
            totalAmount: totalAmount,
            hasPlan,
            hasDevice
          }));
        }
      } catch (error: any) {
        console.error("Error fetching checkout:", error);
        if (error.response?.status === 404) {
          navigate(ROUTES.home);
        }
      }
    };

    if (data) {
      getCheckoutData(sessionId);
    }
  }, [data, sessionId, dispatch]);

  return (
    <Box sx={getPopUpWrapperStyles(isSmallMobile)}>
      <PopUpHeader closePopUp={closePopUp} />
      {products && products.length > 0 ? (
        <>
          {/* If products exist, show list of products */}
          {(!hasPlan || !hasDevice) && (
            <CartNotification
              closePopUp={closePopUp}
              isCartPage={false}
              hasDevice={hasDevice}
              hasPlan={hasPlan}
            />
          )}

          <CartList
              popUpHeight
              products={products}
              isCartPage={false}
              cartId={cartId}
          />
          <PopUpFooter
            totalAmount={totalAmount}
            totalItems={totalItems}
            closePopUp={closePopUp}
          />
        </>
      ) : (
        // Show empty cart
        <EmptyCart closePopUp={closePopUp} />
      )}
    </Box>
  );
};

export default CartPopUp;
